export default __webpack_public_path__ + "static/media/bmr-men-sm.aeb3eb70.png";